var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.086,
    height: 5.737,
    viewBox: "0 0 10.086 5.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down_arrow",
    "data-name": "down arrow",
    d: "M2.531,12.083a.64.64,0,0,0-.131.191.575.575,0,0,0-.047.236.583.583,0,0,0,.08.3.606.606,0,0,0,.216.216.59.59,0,0,0,.307.08.561.561,0,0,0,.429-.179l4.307-4.4H7.1l4.3,4.4a.576.576,0,0,0,.434.179.59.59,0,0,0,.307-.08.606.606,0,0,0,.216-.216.583.583,0,0,0,.08-.3.57.57,0,0,0-.178-.427L7.85,7.575a.592.592,0,0,0-.208-.153.614.614,0,0,0-.246-.05.621.621,0,0,0-.459.2Z",
    transform: "translate(12.439 13.108) rotate(180)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.52817aab83d62715fc68c6a4c6cadf41.svg";
export { ForwardRef as ReactComponent };